<template>
  <div ref="cardRoot" class="product-card" :class="{'product-card--active': panelOpen}">
    <figure
      class="product-card__figure"
      @click="openPanel"
    >
      <img
        v-if="dish.image"
        :src="dish.image"
        class="product-card__image"
        alt=""
      />
      <img
        v-else
        src="../../../assets/food2.jpg"
        class="product-card__image"
        alt=""
      />

      <div class="product-card__info">
        <span
          v-if="dish && dish.categories && dish.categories.length"
          class="product-card__category"
        >
          {{ dish.categories[0].name }}
        </span>
        <div v-if="!panelOpen" class="product-card__title-wrap">
          <h3 class="product-card__name">{{ dish.name }}</h3>
          <span v-if="dish.code" class="product-card__code">{{ dish.code }}</span>
        </div>
      </div>

      <div
        v-if="panelOpen"
        class="product-card__panel"
        @click.stop
      >
        <p class="product-card__panel-title">Add to order</p>

        <PlusMinusInput
          :key="'qty-' + panelKey"
          class="product-card__qty"
          :value="qty"
          @count="onQtyChange"
        />

        <MenuComponent
          v-if="units && units.length > 1"
          buttonText="Add"
          classes="product-card__add-menu"
          :list="units"
          @selected="menuHandler"
          :autoEmit="true"
        />
        <button
          v-else
          type="button"
          class="product-card__btn product-card__btn--add"
          @click="menuHandler(units[0])"
        >
          Add
        </button>

        <button
          type="button"
          class="product-card__btn product-card__btn--cancel"
          @click="closePanel"
        >
          Cancel
        </button>

        <p v-if="qty < 1" class="product-card__error">
          Enter a quantity greater than 0
        </p>
      </div>
    </figure>
  </div>
</template>

<script>
import {PlusMinusInput, MenuComponent} from '@/components/base/index.js';

export default {
  name: 'ProductView',

  props: {
    dish: {
      type: Object,
      default: () => ({}),
    },
    units: {
      type: Array,
      default: () => [],
    },
    activePanelKey: {
      type: [String, Number],
      default: null,
    },
    panelId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      panelOpen: false,
      qty: 1,
      panelKey: 0,
      visiblebuttonadject: false,
    };
  },
  computed: {
    dishKey() {
      if (this.dish && this.dish.id != null) return this.dish.id;
      if (this.dish && this.dish.key != null) return this.dish.key;
      if (this.panelId != null) return this.panelId;
      if (this.dish && this.dish.code) return this.dish.code;
      return null;
    },
  },
  components: {
    PlusMinusInput,
    MenuComponent,
  },
  methods: {
    resetQty() {
      this.qty = 1;
      this.panelKey += 1;
      this.$emit('count', 1);
    },
    bindOutsideClick() {
      this.unbindOutsideClick();
      this._outsideClickHandler = e => {
        if (!this.panelOpen) return;
        const root = this.$refs.cardRoot;
        if (root && !root.contains(e.target)) {
          this.closePanel();
        }
      };
      setTimeout(() => {
        document.addEventListener('click', this._outsideClickHandler);
      }, 0);
    },
    unbindOutsideClick() {
      if (this._outsideClickHandler) {
        document.removeEventListener('click', this._outsideClickHandler);
        this._outsideClickHandler = null;
      }
    },
    closePanel({emitCancel = true} = {}) {
      this.unbindOutsideClick();
      this.panelOpen = false;
      this.resetQty();
      if (emitCancel) {
        this.$emit('Cancel');
      }
      this.$emit('panel-open', null);
      this.cancelvisible();
    },
    cancelvisible() {
      if (this.units[0] && this.units[0].is_adjust) {
        this.visiblebuttonadject = false;
      }
    },
    openPanel() {
      if (this.panelOpen) return;
      this.resetQty();
      this.panelOpen = true;
      this.$emit('panel-open', this.dishKey);
      this.bindOutsideClick();
    },
    menuHandler(index) {
      if (this.qty < 1) return;
      this.$emit('Submit', {
        count: +parseFloat(this.qty),
        dishItem: this.dish,
        unit: index,
      });
      this.closePanel({emitCancel: false});
    },
    onQtyChange(value) {
      const n = parseFloat(value);
      this.qty = !isNaN(n) && n >= 1 ? n : 1;
      this.$emit('count', this.qty);
    },
  },
  watch: {
    dish() {
      this.closePanel();
    },
    activePanelKey(key) {
      if (this.panelOpen && key !== this.dishKey) {
        this.closePanel({emitCancel: false});
      }
    },
  },
  beforeDestroy() {
    this.unbindOutsideClick();
  },
};
</script>

<style scoped>
.product-card {
  position: relative;
  margin-bottom: 15px;
}

.product-card__figure {
  position: relative;
  margin: 0;
  height: 190px;
  overflow: hidden;
  border-radius: 12px;
  background: #e2e8f0;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.1);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.product-card__figure:hover {
  box-shadow: 0 8px 22px rgba(74, 45, 133, 0.18);
  transform: translateY(-2px);
}

.product-card__image {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.35s ease, filter 0.25s ease;
}

.product-card__figure:hover .product-card__image {
  transform: translate(-50%, -50%) scale(1.06);
}

.product-card__info {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
}

.product-card__category {
  align-self: flex-start;
  margin: 12px;
  padding: 5px 10px;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.82);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1;
}

.product-card__title-wrap {
  padding: 48px 14px 12px;
  background: linear-gradient(
    to top,
    rgba(15, 23, 42, 0.88) 0%,
    rgba(15, 23, 42, 0.45) 55%,
    transparent 100%
  );
  text-align: center;
}

.product-card__name {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  color: #fff;
}

.product-card__code {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.04em;
}

.product-card__panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  max-height: 48%;
  padding: 8px 10px 10px;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.52);
  -webkit-backdrop-filter: blur(14px) saturate(1.2);
  backdrop-filter: blur(14px) saturate(1.2);
  border-top: 1px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.14);
}

.product-card__panel::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -28px;
  height: 28px;
  pointer-events: none;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.08));
}

.product-card__panel-title {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--brand-primary);
  text-align: center;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.6);
}

.product-card__btn {
  width: 100%;
  max-width: 200px;
  height: 34px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #fff !important;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.22);
}

.product-card__btn:hover {
  opacity: 0.94;
  transform: translateY(-1px);
}

.product-card__btn--add {
  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-hover) 100%);
}

.product-card__btn--cancel {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
}

.product-card__error {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  text-align: center;
}

.product-card ::v-deep .product-card__qty.qty,
.product-card ::v-deep .product-card__qty .qty {
  margin-top: 0 !important;
  display: inline-flex;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.16);
}

.product-card ::v-deep .product-card__qty .minus,
.product-card ::v-deep .product-card__qty .plus {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  min-width: 34px;
  height: 34px;
  margin: 0;
  padding: 0;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #334155 !important;
  background: #f1f5f9 !important;
  cursor: pointer;
  transition: background 0.15s ease;
}

.product-card ::v-deep .product-card__qty .minus:hover,
.product-card ::v-deep .product-card__qty .plus:hover {
  background: #e2e8f0 !important;
}

.product-card ::v-deep .product-card__qty .count {
  min-width: 42px;
  width: 42px;
  height: 34px;
  margin: 0;
  padding: 0;
  border: none;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  font-size: 16px;
  font-weight: 700;
  line-height: 34px;
  text-align: center;
  color: #1e293b;
  background: #fff;
  appearance: textfield;
  -moz-appearance: textfield;
}

.product-card ::v-deep .product-card__qty .count::-webkit-outer-spin-button,
.product-card ::v-deep .product-card__qty .count::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.product-card ::v-deep .product-card__add-menu {
  width: 100%;
  max-width: 200px;
}

.product-card ::v-deep .product-card__add-menu .btn,
.product-card ::v-deep .product-card__add-menu .btnSubmit {
  width: 100% !important;
  max-width: 200px;
  height: 34px !important;
  margin: 0 !important;
  padding: 0 16px !important;
  border: none !important;
  border-radius: 8px !important;
  background: linear-gradient(135deg, #589442 0%, #3d7a32 100%) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  text-align: center !important;
}
</style>
